/**
 * CustomerDetailTour — guided coachmark tour for the Customer Detail
 * panel (iter150AZ.41, refactored in iter150AZ.42 to share the
 * generalised :mod:`GuidedTour` primitive).
 */
import { useState } from "react";
import { useT } from "@/lib/i18n";
import GuidedTour, { TourHelpButton } from "@/components/GuidedTour";

const STORAGE_KEY = "tour_customer_detail_v1";

function buildSteps(t) {
  return [
    {
      target: '[data-tour="customer-header"]',
      content: t("tour.cd.header",
        "Welcome! This is the Customer Detail panel. Everything you need on this customer lives in the sections below."),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="addresses"]',
      content: t("tour.cd.addresses",
        "Bill-to is the invoice address. Shipping is where parts actually ship. Click Edit to update either one."),
      placement: "top",
    },
    {
      target: '[data-tour="compressors"]',
      content: t("tour.cd.compressors",
        "Compressors this customer owns. Click any row to open the full compressor view and its PM schedule."),
      placement: "top",
    },
    {
      target: '[data-tour="parts"]',
      content: t("tour.cd.parts",
        "Every part this customer has bought. Sort or click a row to jump to the source invoice."),
      placement: "top",
    },
    {
      target: '[data-tour="quotes"]',
      content: t("tour.cd.quotes",
        "Quotes and invoices. The column order matches the workflow: Date → Type → Status → Invoice → Qty → Price → Discount → Total → PO → By."),
      placement: "top",
    },
    {
      target: '[data-tour="notes"]',
      content: t("tour.cd.notes",
        "CRM-style notes with optional AI polishing. Use this for every customer touchpoint."),
      placement: "top",
    },
    {
      target: '[data-tour="journal"]',
      content: t("tour.cd.journal",
        "Audit trail of every monetary event tied to this customer."),
      placement: "top",
    },
  ];
}

export default function CustomerDetailTour({ runFlag, onFinish }) {
  const t = useT();
  const [steps] = useState(() => buildSteps(t));
  return <GuidedTour steps={steps} storageKey={STORAGE_KEY}
                     runFlag={runFlag} onFinish={onFinish} />;
}

export { TourHelpButton };
